<script>
    import { user, workspacePlan } from "../user/user.state.svelte.js";
    import { format, locale } from "svelte-i18n";
    import Sidebar from "../_sidebar/index.svelte";
    import BreadcrumNav from "../../components/breadcrum-nav.svelte";
    import { notificate } from "../../services/notification";
    import workspaceService from '../../services/workspace.js';

    let plan_selected = $state();
    let show_message = $state(false);

    const plans = ["starter", "standard", "premium"];

    const plan_values = {
        starter: {
            label: "STARTER",
            text: $format("page.plan.starter")
        },
        standard: {
            label: "STANDARD",
            text: $format("page.plan.standard")
        },
        premium: {
            label: "RTO",
            text: $format("page.plan.rto")
        },
    };

    const handlePlanChangeSolicit = async () => {
        let result = await notificate('confirm_plan_upgrade', "modal", {});
        if (!result.isConfirmed) {
            return false;
        }

        workspaceService.upgradePlan(plan_selected)
            .then(()=>{
                show_message = true;
                return notificate("request_ok")
            })
            .catch(error=>{
                return notificate("500");
            })
        ;
    }
</script>


<section class="content-header">
    <div class="container-fluid">
        <div class="row">
            <div class="col-6">
                <h1 class="mt-3 mb-3 page-title">
                    <i class="fas fa-rocket fa-xs"></i>
                    {$format("layout.sidebar.plan")}
                </h1>
            </div>
            <div class="col-6">
                <BreadcrumNav
                    routes={[{ label: $format("components.breadcrumb.me") }]}
                />
            </div>
        </div>
    </div>
</section>
<section class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-title ps-3 pt-3">
                        <h3>Plan {workspacePlan.data.toUpperCase()}</h3>
                    </div>
                    <div class="card-body">
                        <div>
                            {$format("page.billing.plan.text")}<a
                                target="_blank"
                                href={$locale != "es"
                                    ? "https://www.securetia.com" +
                                      `/${$locale}/vulseek`
                                    : "https://www.securetia.com/vulseek"}
                                >{$locale != "es"
                                    ? "https://www.securetia.com" +
                                      `/${$locale}/vulseek`
                                    : "https://www.securetia.com/vulseek"}</a
                            >.
                            {@html $format("page.plan.custom_change")}
                        </div>
                    </div>
                </div>
                {#if workspacePlan.data != "premium"}
                    <div class="card">
                        <div class="card-title ps-3 pt-3">
                            <h3>
                                {$format("page.billing.plan.available_plans")}
                            </h3>
                        </div>
                        <div class="card-body">
                            <div class="plan-cards">
                                {#each plans as plan, idx}
                                    {#if idx > plans.findIndex((elem) => elem == workspacePlan.data)}
                                        <article class="plan-card black-box">
                                            <h3>{plan_values[plan].label}</h3>
                                            <p>{plan_values[plan].text}</p>
                                        </article>
                                    {/if}
                                {/each}
                            </div>
                            <footer class="plan-footer">
                                <p>
                                    {$format("page.plan.ready_next_level")}
                                </p>
                                <p>
                                    {@html $format("page.plan.vulseek_helps")}
                                </p>
                                <p>
                                    <select class="form-control w-25" style="margin: 0 auto;" bind:value={plan_selected}>
                                        {#each plans as plan, idx}
                                            {#if idx > plans.findIndex((elem) => elem == workspacePlan.data)}
                                                <option value={plan}>
                                                    {plan_values[plan].label}
                                                </option>
                                            {/if}
                                        {/each}
                                    </select>
                                </p>
                                {#if user.data.role != "viewer"}
                                    <button class="btn btn-success mt-3" onclick={handlePlanChangeSolicit}>{$format("buttons.upgrade_plan")}</button>
                                {:else}
                                    <div class="alert alert-info w-50" style="margin: 0 auto; text-align: left;">
                                        <h5><i class="icon fas fa-info"></i>{$format("page.plan.info")}</h5>
                                        {$format("page.plan.admin_message")}
                                    </div>
                                {/if}
                                {#if show_message}
                                    <div class="mt-3 alert alert-success">{$format("page.plan.request_success")}</div>
                                {/if}
                            </footer>
                        </div>
                    </div>
                {/if}
            </div>
        </div>
    </div>
</section>

<style>
    .plan-cards {
        display: flex;
        gap: 1rem;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-bottom: 2rem;
    }

    .plan-card {
        flex: 1 1 30%;
        border: 1px solid #ccc;
        border-radius: 12px;
        padding: 1rem;
        box-sizing: border-box;
        background-color: #fff;
        transition: box-shadow 0.2s ease;
    }

    .plan-card:hover {
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

    .plan-card h3 {
        font-weight: 600;
        margin-bottom: 0.5rem;
    }

    .plan-card.black-box h3 {
        color: #b91c1c; /* rojo */
    }

    .plan-footer {
        text-align: center;
        color: #555;
    }

    .plan-footer p:first-child {
        font-weight: 600;
        color: #333;
        font-size: 1.1rem;
        margin-bottom: 0.25rem;
    }
</style>
